var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuestReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 0.5,
    stroke: "#5D6F88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.44792V9H3.875V8.32292C3.875 8.18843 3.88889 8.05932 3.91667 7.93559C3.94444 7.81186 3.98611 7.68976 4.04167 7.56929C3.96528 7.55782 3.88809 7.55035 3.81011 7.54688C3.73213 7.5434 3.6509 7.54167 3.56642 7.54167C3.09853 7.54167 2.72049 7.62575 2.43229 7.79392C2.1441 7.96209 2 8.18009 2 8.44792Z",
    fill: "#5D6F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.32292V9H9.5V8.32292C9.5 8.10069 9.44097 7.89757 9.32292 7.71354C9.20486 7.52951 9.03472 7.36806 8.8125 7.22917C8.59028 7.09028 8.32465 6.98611 8.01562 6.91667C7.7066 6.84722 7.36806 6.8125 7 6.8125C6.63889 6.8125 6.30382 6.84722 5.99479 6.91667C5.68576 6.98611 5.42014 7.09028 5.19792 7.22917C4.97569 7.36806 4.80382 7.52951 4.68229 7.71354C4.56076 7.89757 4.5 8.10069 4.5 8.32292Z",
    fill: "#5D6F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 8.32292V9H12V8.44792C12 8.17386 11.8568 7.95431 11.5703 7.78925C11.2839 7.62419 10.9062 7.54167 10.4375 7.54167C10.3565 7.54167 10.2773 7.5434 10.1997 7.54688C10.1221 7.55035 10.0451 7.55808 9.96875 7.57007C10.0243 7.69002 10.0642 7.811 10.0885 7.93301C10.1128 8.05502 10.125 8.18499 10.125 8.32292Z",
    fill: "#5D6F88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04688 7.01498C3.18924 7.15777 3.35961 7.22917 3.55799 7.22917C3.76239 7.22917 3.93576 7.15799 4.07812 7.01563C4.22049 6.87326 4.29167 6.70289 4.29167 6.50451C4.29167 6.30011 4.22049 6.12674 4.07812 5.98438C3.93576 5.84201 3.76389 5.77083 3.5625 5.77083C3.36198 5.77083 3.19032 5.84201 3.04752 5.98438C2.90473 6.12674 2.83333 6.29861 2.83333 6.5C2.83333 6.70052 2.90451 6.87218 3.04688 7.01498Z",
    fill: "#5D6F88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92188 7.01498C10.0642 7.15777 10.2346 7.22917 10.433 7.22917C10.6374 7.22917 10.8108 7.15799 10.9531 7.01563C11.0955 6.87326 11.1667 6.70289 11.1667 6.50451C11.1667 6.30011 11.0955 6.12674 10.9531 5.98438C10.8108 5.84201 10.6389 5.77083 10.4375 5.77083C10.237 5.77083 10.0653 5.84201 9.92252 5.98438C9.77973 6.12674 9.70833 6.29861 9.70833 6.5C9.70833 6.70052 9.77951 6.87218 9.92188 7.01498Z",
    fill: "#5D6F88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11458 6.13542C6.35764 6.37847 6.65278 6.5 7 6.5C7.35417 6.5 7.65104 6.37847 7.89062 6.13542C8.13021 5.89236 8.25 5.59722 8.25 5.25C8.25 4.89583 8.13021 4.59896 7.89062 4.35938C7.65104 4.11979 7.35417 4 7 4C6.65278 4 6.35764 4.11979 6.11458 4.35938C5.87153 4.59896 5.75 4.89583 5.75 5.25C5.75 5.59722 5.87153 5.89236 6.11458 6.13542Z",
    fill: "#5D6F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestReport);
export default __webpack_public_path__ + "static/media/guest_report.2fbef05ed2b72be4808839fe965cad08.svg";
export { ForwardRef as ReactComponent };